export default [
    {
        path: 'exame-agendado-realizado',
        component: () => import(
            /* webpackChunkName: 'exame-imagem-exame-agendado-realizado' */
            '@/views/exame-imagem/exame-agendado-realizado/Index'
        ),
        redirect: 'exame-agendado-realizado/index',
        children: [
            {
                name: 'exame-imagem-exame-agendado-realizado-index',
                path: 'index',
                props: true,
                component: () => import(
                    /* webpackChunkName: 'exame-imagem-exame-agendado-realizado' */
                    '@/views/exame-imagem/exame-agendado-realizado/List.vue'
                ),
            },
            {
                name: 'exame-imagem-exame-agendado-realizado-create',
                path: 'create',
                props: true,
                component: () => import(
                    /* webpackChunkName: 'exame-imagem-exame-agendado-realizado' */
                    '@/views/exame-imagem/exame-agendado-realizado/Form.vue'
                ),
            },
        ],
    }
]